module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_map_white-c720cb76f578e71239c1311620bf12a4.svg";